import React, { useEffect, useState } from "react";
import countryData from "../../countryData.json"; // your JSON data
import "./CountryDetails.css";


export default function CountryDetails({ countryName }) {
  const [country, setCountry] = useState(null);

  useEffect(() => {
    if (!countryName) return;
    const selected = countryData.find(
      (c) => c.name.toLowerCase() === countryName.toLowerCase()
    );
    console.log(selected)
    setCountry(selected || null);
  }, [countryName]);

  if (!country) {
    return (
      <div className="country-details">
        <p>Select a country on the globe to see full simulation</p>
      </div>
    );
  }

  return (
    <div className="country-details">
      {/* Basic Info */}
      <section>
        <p><strong>Country:</strong> {country.name}</p>
        <p><strong>Population:</strong> {country.population.toLocaleString()}</p>
        <p><strong>Area:</strong> {country.area.toLocaleString()}</p>
        <p><strong>Currency:</strong> {country.currency.name} ({country.currency.symbol})</p>
        <p><strong>Banking System:</strong> {country.bankingSystem}</p>
        <p><strong>Capital:</strong> {country.capital}</p>
        <p><strong>Language:</strong> {country.language}</p>
      </section>

      {/* Financial Metrics */}
      <section>
        <h2>Financial Metrics</h2>
        <p><strong>GDP:</strong> {country.gdp.toLocaleString()}</p>
        <p><strong>Median Income:</strong> {country.medianIncome.toLocaleString()}</p>
        <p><strong>Inflation Rate:</strong> {country.inflation}</p>
        <p><strong>Unemployment Rate:</strong> {country.unemployment}</p>
        <p><strong>Debt-to-GDP:</strong> {country.debtToGDP}</p>
      </section>

      {/* Banking & Finance */}
      <section>
        <h2>Banking & Finance</h2>
        <p><strong>Number of Banks:</strong> {country.numberOfBanks}</p>
        <p><strong>Central Bank:</strong> {country.centralBank}</p>
        <p><strong>Interest Rate:</strong> {country.interestRate}</p>
        <p><strong>Online Banking Penetration:</strong> {country.onlineBanking}</p>
        <p><strong>Cash vs Digital Ratio:</strong> {country.cashDigitalRatio}</p>
      </section>

      {/* Crypto Metrics */}
      <section>
        <h2>Cryptocurrency</h2>
        <p><strong>Crypto Adoption:</strong> {country.cryptoAdoption}</p>
        <p><strong>Crypto Exchanges:</strong> {country.cryptoExchanges}</p>
        <p><strong>Legal Status:</strong> {country.cryptoLegalStatus}</p>
        <p><strong>Stablecoin Usage:</strong> {country.stablecoinUsage}</p>
        <p><strong>NFT Market:</strong> {country.nftMarket}</p>
      </section>

      {/* Economy Sectors */}
      <section>
        <h2>Economy Sectors</h2>
        {Object.entries(country.sectors).map(([sector, value]) => (
          <p key={sector}><strong>{sector}:</strong> {value}</p>
        ))}
      </section>

      {/* Social Metrics */}
      <section>
        <h2>Social Metrics</h2>
        <p><strong>Cost of Living Index:</strong> {country.costOfLiving}</p>
        <p><strong>Average Rent:</strong> {country.averageRent}</p>
        <p><strong>Healthcare Access:</strong> {country.healthcareAccess}</p>
        <p><strong>Education Index:</strong> {country.educationIndex}</p>
      </section>

      
    </div>
  );
}
